import PageNav from "@/components/PageNav/PageNav.vue";
import Footer from "@/components/Footer/footer.vue";
import notlog from "@/components/notlog/notlog.vue"
import notdate from "@/components/notdate/notdate.vue";
import fundsTransfe from "@/components/fundsTransfe/fundsTransfe.vue";
import {mapState, mapGetters} from "vuex";

import currencyApi from '@/common/api/currency';
import contractApi from '@/common/api/contract';
import {KLineChartPro} from "@klinecharts/pro";
import config from "@/common/api/config";
import { applyKlineProTheme } from '@/common/util/klineTheme';

const currentKey = 'contract-current';

let klineCharts = false;
let _ticker = false;
let upset = false;
let klineChartSession = 0;
let klineSubscriptionToken = 0;
let chartPeriod = false;

let firstPrice;
let last;
const time = {
    '1s':0,
    '1m':1,
    '5m':5,
    '15m':15,
    '30m':30,
    '1H':60,
    '4H':240,
    '12H':720,
    '1D':1440,
    '1W':10080
}

let socket = false;
let socketInterval = false;
let amax;
let bmax;

//资金废率相关
let timecaluc = false;
let timestamp = 0;

let page = 1;

function invalidateKlineSession() {
    klineChartSession += 1;
    klineSubscriptionToken += 1;
    last = undefined;

    if (upset !== false) {
        clearInterval(upset);
        upset = false;
    }
}

export default {
    components: {Footer, PageNav, notlog, fundsTransfe,notdate},
    data() {
        return {
            coinName: "BTC",
            coinType: "USDT",
            chartType: 0, //图表类型
            chartTabIndex: 0, //图表or概述
            timeOptions: ['分时', '1分钟', '3分钟', '5分钟', '15分钟', '30分钟', '1小时', '2小时', '4小时', '6小时', '8小时', '12小时', '1天', '3天', '周线', '月线',],
            timeEdit: false,
            selectTime: ['分时', '1分钟', '3分钟', '5分钟'],
            timeActive: 0,
            priceTypeVal: '最新价格',
            tableOption: [
                {
                    name: "BTC",
                    type: "USDT",
                    rate: "-0.25%"
                }
            ],
            tableActive: 0,
            aboutCoin: false,
            decimal: "0.000001",
            listType: 0,
            List: [
                {
                    price: "0.061888",
                    num: "216000",
                    total: "1985264",
                }],
            timer: "",
            btnActive: 0,
            modeOption: ["0", "1", "2"],
            modeIndex: 0,
            subtabActive: 0,
            marks: {
                0: '0%',
                25: '25%',
                50: '50%',
                75: '75%',
                100: '100%'
            },
            like: false,
            marginModel: false,
            leverSlider: {
                0: '1X',
                25: '25X',
                50: '50X',
                75: '75X',
                100: '100X',
                125: '125X'
            },
            leverArm: false,
            leverVal: 20,
            balanceTip: false,
            tabIndex: 0,
            tabOption: [],
            buying: 1,
            calculator: false, //计算器
            transfeShow: false, //划转
            checked: false,
            placeOrder: false, //下单
            closePotion: false, //平仓
            flashClose: false, //闪电平仓
            profitLossPop: false, //止盈止损
            closePotionTab: ['limit', 'market'],
            wdOrder: false, //撤单
            orderInfoPopup: false, //订单详情
            settingDrawer: false, //设置,

            currency:[],//交易对
            current:{},//当前的交易对
            currencyTab:0,//选中的交易对
            searchVal:"",//搜索

            asks:[],
            bids:[],
            market:{},
            trades:[],
            timeInt:"",

            //仓位模式绑定
            all:true,
            signal:false,
            positionModel : 0, //0全仓 1逐仓

            balance : false, //资金余额,

            //下单参数
            price:"", //下单价格
            wprice:"", //触发价格
            amount:"", //下单数量
            amounType:1, //数量类型 - 默认USDT
            limitType:0, //触发价格是 0 限价 1市场价
            rate : 0,
            


            margin:'0.00',
            submitDirection:false,
            loading:false,

        //     仓位
            position:{position:[],entrust:[],entrustP:[]},

            pindex:false ,//操作平仓的索引

            pamount : '', //平仓数量
            pprice : '', //平仓价格,

            wptype:0, //止盈平仓类型
            wamount :"",//止盈平仓数量
            wpprice:"",//止盈平仓价格
            wpwprice:"",//止盈触发价格

            lptype:0,
            lprice:"",
            lwprice:"",
            lamount : "",//止损平仓数量

            tabPanelIndex : 0,

            history:[],

            cleverVal : 1,//计算器滑动
            cprice : "",
            cwprice:"",
            camount : "",
            currencyInfo:false,
            
            // 诊断监控器
            diagnosticInterval: null
        }
    },
    mounted() {
        console.log("合约页面 mounted");
        
        try {
            // 初始化计算器标签页选项
            this.initializeTabOption();
            
            // 按顺序初始化各种功能
            this.getContractCurrency();
            
            this.getPositionModel();
            this.getPositionLever();

            this.getBalance();
            if(this.isLogin){
                this.getBalance();
                this.getPosition();
                
                // 设置定时器定期更新数据
                this.dataUpdateTimer = setInterval(() => {
                    if(this.isLogin){
                        this.getBalance();
                        this.getPosition();
                    }
                }, 10000); // 每10秒更新一次
            }
        } catch (error) {
            console.error('❌ 合约页面初始化失败:', error);
        }
    },
    computed: {
        ...mapState(['userTheme']),
        ...mapGetters(['isLogin','userId'])
    },
    watch:{
        userTheme(newTheme, oldTheme) {
            if (newTheme !== oldTheme && klineCharts) {
                this.$nextTick(() => {
                    applyKlineProTheme(
                        klineCharts,
                        newTheme,
                        document.getElementById('chartBox')
                    );
                });
            }
        },
        // 监听语言变化，重新创建K线图（因为locale只能在创建时设置）
        '$i18n.locale'(newLocale, oldLocale) {
            if (newLocale !== oldLocale && klineCharts) {
                console.log('🌐 合约页面语言变化:', { oldLocale, newLocale });
                const klineLocale = this.getKlineLocale();
                
                // KLineChartPro已内置zh-CN和en-US语言包，无需手动加载
                // 语言切换时重新创建图表即可，库会自动使用正确的语言包
                console.log('🔧 K线图语言已更新:', klineLocale);
                
                // KLineChartPro的locale只能在创建时设置，语言切换时需要重新创建图表
                this.$nextTick(async () => {
                    if (klineCharts) {
                        try {
                            console.log('🔄 语言变化，重新创建K线图以应用新语言...');
                            // 销毁旧图表
                            invalidateKlineSession();
                            klineCharts.destroy();
                            klineCharts = false;
                            // 无需等待，库已内置语言包
                            // 重新创建图表
                            await this.createCharts();
                            console.log('✅ 合约K线图语言更新成功:', klineLocale);
                        } catch (error) {
                            console.error('❌ 合约K线图语言更新失败:', error);
                        }
                    }
                });
            }
        },
        positionModel(v){
            console.log("position model : ",v);
        },
        isLogin(v){
            if(v){
                this.getBalance();
                this.getPosition();
            }
        },
        modeIndex(v){
            this.price = '';
            this.amount = '';
            this.rate = 0;
        },
        amounType(v){
            this.amount = '';
            this.rate = 0;
        },
        '$i18n.locale'() {
            this.initializeTabOption();
            this.$forceUpdate();
        },
        calculator(newVal) {
            if (newVal) {
                // 计算器打开时重新初始化标签页
                this.$nextTick(() => {
                    this.initializeTabOption();
                });
            }
        },
        '$i18n.locale'() {
            // 语言切换时强制重新渲染
            this.$forceUpdate();
        }
    },
    methods: {
        // 初始化计算器标签页选项
        initializeTabOption() {
            if (!this.$t) return;
            this.tabOption = [
                this.$t('futures.profit_calculator'),
                this.$t('futures.liquidation_price')
            ];
        },
        closePositionByForm(direction){
            //通过操作表单平仓
            if(this.amount === '' || this.amount <= 0){
                this.$notification.info(this.$t('futures.please_enter_close_amount'));
                return false;
            }
            if(this.modeIndex !== 1 && (this.price === '' || this.price <= 0)){
                this.$notification.info(this.$t('futures.please_enter_close_price'));
                return false;
            }
            let position = this.position.position.filter((item)=>{
                if(parseInt(item['currency_id']) === parseInt(this.current['id']) && parseInt(item['direction']) === direction){
                    return true;
                }
                return false;
            });
            if(position.length <= 0){
                this.$notification.info(this.$t('futures.no_closeable_position'));
                return false;
            }
            let id = position[0]['id'];
            const form = {
                id: id,
                pamount: this.$util.str2number(this.amount),
                ptype: this.modeIndex !== 1 ? 2 : 1,
                price: this.modeIndex !== 1 ? this.price : _ticker['c'],
                wprice: this.modeIndex === 2 ? this.wprice : 0
            };
            this.loading = true;
            contractApi.closeOrder(form).then(res=>{
                this.loading = false;
                this.$notification.info(res.message);
                if(res.code === 200){
                    // 立即更新持仓和余额
                    this.getPosition();
                    this.getBalance();
                    
                    // 延迟再次更新确保数据同步
                    setTimeout(()=>{
                        this.getPosition();
                        this.getBalance();
                    },1000);
                    
                    // 再次延迟更新
                    setTimeout(()=>{
                        this.getPosition();
                        this.getBalance();
                    },3000);
                    
                    this.price = '';
                    this.amount = '';
                    this.rate = 0;
                }
            })
        },
        getStopProfit(amount){
            //获取平仓数量的预估盈亏
            if(amount === '' || amount <= 0){
                return '0.00';
            }
            let price = parseFloat(this.current['new_price']);
            if(this.modeIndex === 0){
                price = parseFloat(this.price);
            }
            if(this.modeIndex === 2){
                price = parseFloat(this.price)
            }
            let longPirce = this.getPositionOpenPrice(1);
            let long = longPirce === 0 ? 0 : (price - longPirce) * amount;
            let shortPrice = this.getPositionOpenPrice(2);
            let short = shortPrice === 0 ? 0 :(shortPrice - price) * amount;
            return {'long':long,'short':short}
        },
        getPositionOpenPrice(direction){
            let price = 0;
            this.position.position.map((item)=>{
                if(parseInt(item.currency_id) === parseInt(this.current['id']) && parseInt(item['direction']) === direction && price === 0){
                    price = parseFloat(item['price']);
                }
            });
            return price;
        },
        getPositionAmount(direction){
            //平仓获取已有仓位的可平数量
            let amount = 0;
            if(this.position.position.length <= 0){
                return 0;
            }
            this.position.position.map((item)=>{
                if(parseInt(item.currency_id) === parseInt(this.current['id']) && parseInt(item.direction) === direction){
                    amount += parseFloat(item['amount']) - parseFloat(item['close']);
                }
            });
            return amount;
        },
        cancelOrder(){
            //撤单
            this.loading = true;
            let opid = false;
            if(this.tabPanelIndex === 2){
                opid = this.position.entrust[this.pindex]['id']
            }
            if(this.tabPanelIndex === 3){
                opid = this.position.entrustP[this.pindex]['id'];
            }
            contractApi.cancelOpeartion(opid).then(res=>{
                this.loading = false;
                this.wdOrder = false;
                this.$notification.info(res.message);
                if(res.code === 200){
                    // 立即更新持仓和余额
                    this.getPosition();
                    this.getBalance();
                    
                    // 延迟再次更新确保数据同步
                    setTimeout(()=>{
                        this.getPosition();
                        this.getBalance();
                    },1000);
                    
                    // 再次延迟更新
                    setTimeout(()=>{
                        this.getPosition();
                        this.getBalance();
                    },3000);
                }
            });
        },
        wlProfitSet(){
            //止盈止损设置提交

            if(this.wamount === '' || this.wamount <= 0){
                this.$notification.info(this.$t('futures.please_enter_profit_amount'));
                return false;
            }
            if(this.lamount === '' || this.lamount <= 0){
                this.$notification.info(this.$t('futures.please_enter_loss_amount'));
                return false;
            }
            if(this.wpwprice === '' || this.wpwprice <= 0){
                this.$notification.info(this.$t('futures.please_enter_profit_trigger_price'));
                return false;
            }
            if(this.lwprice === '' || this.lwprice <= 0){
                this.$notification.info(this.$t('futures.please_enter_loss_trigger_price'));
                return false;
            }
            if(this.wptype === 1 && (this.wpprice === '' || this.wpprice <= 0)){
                this.$notification.info(this.$t('futures.please_enter_profit_close_price'));
                return false;
            }
            if(this.lptype === 1 && (this.lprice === '' || this.lprice <= 0)){
                this.$notification.info(this.$t('futures.please_enter_loss_close_price'));
                return false;
            }
            const form = {
                cid: this.position.position[this.pindex]['id'],
                profitType: this.wptype,
                profitPprice: this.wptype === 0 ? this.wpwprice : this.wpprice,
                profitPwprice: this.wpwprice,
                profitAmount: this.wamount,
                loseType: this.lptype,
                losePprice: this.lptype === 0 ? this.lwprice : this.lprice,
                losePwrice: this.lwprice,
                loseAmount: this.lamount
            };

            this.loading = true;
            contractApi.limitProfit(form).then(res=>{
               this.loading = false;
                this.profitLossPop = false;
                this.$notification.info(res.message);
                if(res.code === 200){
                    // 立即更新持仓和余额
                    this.getPosition();
                    this.getBalance();
                    
                    // 延迟再次更新确保数据同步
                    setTimeout(()=>{
                        this.getPosition();
                        this.getBalance();
                    },1000);
                    
                    // 再次延迟更新
                    setTimeout(()=>{
                        this.getPosition();
                        this.getBalance();
                    },3000);
                }
            });
        },
        llstopChange(e){
            //止盈止损的滑动数量计算
            let amount = this.position.position[this.pindex]['amount'] - this.position.position[this.pindex]['close'];
            this.lamount = parseFloat(amount * (e/100)).toFixed(8);
        },
        lsliderChange(e){
            //止盈止损的滑动数量计算
            let amount = this.position.position[this.pindex]['amount'] - this.position.position[this.pindex]['close'];
            this.wamount = parseFloat(amount * (e/100)).toFixed(8);
        },
        getPositionPamount(new_price){
            //获取平仓的持仓盈亏
            if(this.pamount === ''){
                return '--';
            }
            let amount = this.pamount;
            let o = parseFloat(this.position.position[this.pindex]['price']);
            let newPrice = this.pprice === '' ? parseFloat(_ticker['c']):parseFloat(this.pprice);
            if (parseInt(this.position.position[this.pindex]['direction']) === 1) {
                return this.$util.thousandSeparator(amount * (newPrice - o), 4);
            } else {
                return this.$util.thousandSeparator(amount * (o - newPrice), 4);
            }
        },
        psliderChange(e){
            //平仓滚动条滑动数量计算
            let amount = this.position.position[this.pindex]['amount'] - this.position.position[this.pindex]['close'];
            this.pamount = parseFloat(amount * (e / 100)).toFixed(8);
        },
        tabChange(e){
            //订单tab切换数据加载
            this.tabPanelIndex = parseInt(e);
            this.pindex = false;
            if(parseInt(e) === 1){
                this.getPosition();
            }
            if(this.tabPanelIndex === 4 || this.tabPanelIndex === 5){
                page = 1;
                this.history = [];
                this.getHistory();
            }
        },
        getHistory(){
            contractApi.getHistory(this.current['id'],page).then(res=>{
                if(res.code === 200){
                    if (page === 1) {
                        this.history['entrust'] = res.data['entrust'];
                        this.history['history'] = res.data['history'];
                        this.history['profit'] = res.data['profit'];
                    } else {
                        // 否则，为加载更多操作，追加数据
                        this.history['entrust']['list'] = this.history['entrust']['list'].concat(res.data['entrust']['list']);
                        this.history['history']['list'] = this.history['history']['list'].concat(res.data['history']['list']);
                        this.history['profit']['list'] = this.history['profit']['list'].concat(res.data['profit']['list']);
                    }
                }
            });
        },
        

        closePositions(){
            if (this.pamount === '' || parseFloat(this.pamount) <= 0) {
                this.$notification.info(this.$t('futures.please_enter_close_amount'));
                return false;
            }
            if(this.tabIndex === 0 && (this.pprice === '' || this.pprice <= 0)){
                this.$notification.info(this.$t('futures.please_enter_close_price'));
                return false;
            }

            const form = {
                id: this.position.position[this.pindex]['id'],
                pamount: this.$util.str2number(this.pamount),
                ptype: this.tabIndex === 0 ? 2 : 1,
                price: this.tabIndex === 0 ? this.pprice : _ticker['c'],
                wprice: 0
            };
            this.loading = true;
            let amount = this.position.position[this.pindex]['amount'] - this.position.position[this.pindex]['close'];
            contractApi.closeOrder(form).then(res => {
                this.loading = false;
                this.closePotion = false;
                try {
                    if (res.code !== 200) {
                        this.$notification.info(res.message);
                    }
                } catch (e) {
                    console.log(e);
                }
                
                if(res.code === 200){
                    // 立即更新持仓和余额
                    this.getPosition();
                    this.getBalance();
                    
                    // 延迟再次更新确保数据同步
                    setTimeout(()=>{
                        this.getPosition();
                        this.getBalance();
                    },1000);
                    
                    // 再次延迟更新
                    setTimeout(()=>{
                        this.getPosition();
                        this.getBalance();
                    },3000);
                }
                
                if(this.tabIndex === 1){
                    if(parseFloat(form['pamount']) >= parseFloat(amount)){
                        this.position.position = this.position.position.filter((item)=>{
                            return parseInt(item['id']) !== parseInt(form['id']);
                        });
                    }else{
                        this.position.position[this.pindex]['close'] = amount - parseFloat(this.pamount);
                    }
                }
                this.pindex = false;
            }).catch((e) => {
                console.log(e);
                this.loading = false;
                this.closePotion = false;
                this.$notification.info(e);
            })
        },
        lightClose(){
            //闪电平仓
            this.loading = true;
            const form = {
                id : this.position.position[this.pindex]['id'],
                pamount : parseFloat(parseFloat(this.position.position[this.pindex]['amount']) - parseFloat(this.position.position[this.pindex]['close'])).toFixed(8),
                ptype:1,
                price : this.current['new_price'],
                wprice : 0
            };
            contractApi.closeOrder(form).then(res=>{
                this.loading = false;
                this.flashClose = false;
                this.$notification.info(res.message);
                if(res.code === 200){
                    this.pindex = false;
                    
                    // 立即更新持仓和余额
                    this.getPosition();
                    this.getBalance();
                    
                    // 延迟再次更新确保数据同步
                    setTimeout(()=>{
                        this.getPosition();
                        this.getBalance();
                    },1000);
                    
                    // 再次延迟更新
                    setTimeout(()=>{
                        this.getPosition();
                        this.getBalance();
                    },3000);
                    
                    // 本地更新持仓列表（可选，因为getPosition会重新获取）
                    this.position.position = this.position.position.filter((item)=>{
                        return parseInt(item['id']) !== parseInt(form['id']);
                    });
                }
            })
        },
        getMarginRate(mt,m,p){
            //获取保证金率，全仓  : 本金-亏损/保证金 ,亏损/保证金
            if(parseInt(mt) === 1){
                return this.$util.thousandSeparator((parseFloat(this.balance.legal_balance) - parseFloat(p)) / parseFloat(m) * 100);
            }
            return this.$util.thousandSeparator(parseFloat(p) / parseFloat(m) * 100);
        },
        calacPosition(ticker){
            try{
                let position = this.position.position;
                if (position.length <= 0) {
                    return false;
                }
                for (let i = 0; i < position.length; i++) {
                    if (parseInt(position[i]['currency_id']) === parseInt(this.current['id'])) {
                        let item = position[i]
                        let amount = parseFloat(item['amount']) - parseFloat(item['close']);
                        let o = parseFloat(item['price']);
                        let newPrice = parseFloat(_ticker['c']);
                        let p = 0;
                        if (parseInt(item['direction']) === 1) {
                            p = amount * (newPrice - o);
                        } else {
                            p = amount * (o - newPrice);
                        }
                        item['p'] = this.$util.thousandSeparator(p ,4);
                        //rate
                        let pr = 0;
                        if (parseInt(item['direction']) === 1) {
                            pr = item.amount * (newPrice - item.price) / item.margin * 100;
                        } else {
                            pr = item.amount * (item.price - newPrice) / item.margin * 100;
                        }
                        item['rate'] = pr > 0 ? '+' + this.$util.thousandSeparator(pr, 2) : this.$util.thousandSeparator(pr)

                        let mr = 0;
                        if (parseInt(item['margin_type']) === 1) {
                            mr = (parseFloat(this.balance.legal_balance) + p) / item['margin'] * 100
                        } else {
                            mr = (parseFloat(item['margin']) + p) / parseFloat(item['margin']) * 100;
                        }
                        item['mr'] = this.$util.thousandSeparator(mr, 2);
                        position[i] = item;
                    }
                }
                this.position.position = position;
            }catch (e){}
        },
        getPosition(){
            contractApi.getPositionList(this.current['id']).then(res => {
                if (res.code === 200) {
                    let position = res.data.position;
                    position.map((item) => {
                        item['p'] = 0;
                        return item;
                    });
                    res.data.position = position;
                    this.position = res.data;
                    this.getMuiltByPosition();
                } else {
                    this.position = {
                        position: [],
                        totalAmount: []
                    };
                }
            }).catch(error => {
                console.error('❌ 获取持仓信息失败:', error);
                
                // 如果是401错误，静默处理
                if (error.message && error.message.includes('401')) {
                    console.log('ℹ️ 用户未登录，持仓信息获取失败');
                    this.position = {
                        position: [],
                        totalAmount: []
                    };
                    return;
                }
                
                // 其他错误设置空数据
                this.position = {
                    position: [],
                    totalAmount: []
                };
            });
        },
        getMuiltByPosition() {
            if (this.position.position.length > 0) {
                this.leverVal = this.position.position[0]['muilt'];
                this.$util.setCache('futures-lever',this.leverVal);
                this.tmargin = this.position.position[0]['margin_type'];
                this.positionModel = parseInt(this.tmargin) === 1 ? 0 : 1;
                this.$util.setCache("positionModel",this.positionModel);
            }
        },
        submitOrder(direction,show=true){
            if(this.amount === '' || this.amount <= 0){
                this.loading = false;
                return false;
            }
            if(!this.balance || this.balance.legal_balance <= 0){
                this.loading = false;
                this.$notification.info(this.$t('futures.insufficient_balance'));
                return false;
            }
            if(parseFloat(this.getMarginAmount(0)) > parseFloat(this.balance.legal_balance)){
                this.loading = false;
                this.$notification.info(this.$t('futures.insufficient_balance'));
                return false;
            }
            if(parseFloat(this.getMarginAmount(0)) < parseFloat(this.current['min_amount'])){
                this.loading = false;
                this.$notification.info(this.$t('futures.min_margin_limit', {amount: this.current['min_amount']}));
                return  false;
            }
            if(this.modeIndex === 2 && this.limitType === 0 && this.wprice === ''){
                this.loading = false;
                this.$notification.info(this.$t('futures.please_enter_trigger_price'));
                return  false;
            }
            if(this.modeIndex === 1 && this.amount === ''){
                this.loading = false;
                this.$notification.info(this.$t('futures.please_enter_open_amount'));
                return  false;
            }
            this.submitDirection = parseInt(direction);
            this.loading = true;
            let tip = this.$util.getCache('tip','');
            if(show && tip !== '' && parseInt(tip) === 0){
                this.doSubmit();
            }else{
                if(show){
                    this.placeOrder = true;
                }else{
                    //直接提交订单
                    if(this.checked){
                        this.$util.setCache('tip',0);
                    }
                    this.doSubmit();
                }
            }
        },
        doSubmit(){
            let uamount = 0;
            //开仓头寸计算
            if (this.modeIndex === 1) {
                uamount = this.amounType === 0 ?
                    this.$util.str2number(this.$util.thousandSeparator(this.amount * this.current['new_price'], 4)) :
                    this.amount;
            }
            if (this.modeIndex !== 1) {
                const order_price = this.modeIndex === 0 ? this.$util.str2number(this.price) : this.$util.str2number(this.wprice);
                uamount = this.amounType === 0 ?
                    this.$util.str2number(this.$util.thousandSeparator(this.amount * order_price, 4)) :
                    this.amount;
            }

            //开仓数量计算
            let amount = 0;
            if (this.amounType === 0) {
                amount = this.amount;
            } else {
                if (this.modeIndex === 1) {
                    amount = parseFloat(parseFloat(this.amount) / parseFloat(this.current['new_price'])).toFixed(this
                        .current['trade_decimals'])
                }
                if (this.modeIndex === 2) {
                    amount = parseFloat(parseFloat(this.amount) / parseFloat(this.$util.str2number(this.wprice)))
                        .toFixed(this.current['trade_decimals'])
                }
            }

            let form = {
                cm_id: 2,
                currency_id: this.current['id'],
                legal_id: 10, // 添加legal_id字段
                direction: this.submitDirection,
                muilt: this.leverVal,
                order_type: this.modeIndex === 0 ? 2 : this.modeIndex === 1 ? 1:3,
                margin_type: this.positionModel === 0 ? 1 : 2
            };
            
            // 根据amounType决定使用amount还是uamount
            if (this.amounType === 0) {
                // 币种数量下单
                form.amount = amount;
            } else {
                // USDT金额下单
                form.uamount = uamount;
            }

            if (this.modeIndex === 0) {
                form['price'] = this.$util.str2number(this.price); //限价
                form['nowprice'] = this.$util.str2number(this.current['new_price']); //当前价格
            }
            if (this.modeIndex === 1) {
                form['price'] = this.$util.str2number(this.current['new_price']); //市价
                form['nowprice'] = this.$util.str2number(this.current['new_price']); //当前价格
            }
            if (this.modeIndex === 2) {
                form['price'] = this.$util.str2number(this.price === '' ? this.current['new_price'] : this.price); //条件单的委托价格
                form['nowprice'] = this.$util.str2number(this.current['new_price']); //当前价格
                form['wprice'] = this.$util.str2number(this.wprice); //条件单的触发价格
            }


            this.placeOrder = false;

            contractApi.submitOrder(form).then(res=>{
                this.loading = false;
                if(res.code !== 200){
                    this.$notification.info(res.message);
                    return false;
                }
                
                // 清空表单
                this.amount = '';
                this.price = '';
                this.wprice = '';
                this.rate = 0;
                

                
                // 立即更新数据
                this.getPosition();
                this.getBalance();
                
                // 延迟再次更新以确保数据同步
                setTimeout(()=>{
                    this.getPosition();
                    this.getBalance();
                },1000);
                
                // 再次延迟更新
                setTimeout(()=>{
                    this.getPosition();
                    this.getBalance();
                },3000);
                
                this.$notification.info(this.$t('futures.order_success'));
            }).catch((e)=>{
                this.loading = false;
                this.$notification.info(e);
            });
        },
        getMarginAmount(new_price){
            if(this.amount === '' || this.amount <= 0){
                return '0.00';
            }
            
            // 获取当前价格
            let currentPrice = _ticker ? parseFloat(_ticker['c']) : (this.current && this.current.new_price ? parseFloat(this.current.new_price) : 0);
            
            if(this.modeIndex === 0){
                return this.amounType === 0 ?
                    this.amount / this.leverVal * currentPrice:
                    this.amount / this.leverVal
            }else{
                return this.price === '' ?
                    this.amounType === 0 ?
                        this.amount / this.leverVal * currentPrice:
                        this.amount / this.leverVal:
                    this.amounType === 0 ?
                        this.amount / this.leverVal * parseFloat(this.price):
                        this.amount / this.leverVal
            }
        },
        getTopAmount(d = 1,new_price){
            // 如果没有ticker数据，使用当前币种的最新价格
            let currentPrice = _ticker ? parseFloat(_ticker['c']) : (this.current && this.current.new_price ? parseFloat(this.current.new_price) : 0);
            
            if(!currentPrice || currentPrice <= 0){
                console.warn('⚠️ 无法获取当前价格，ticker:', _ticker, 'current.new_price:', this.current?.new_price);
                return '0.00';
            }
            
            if (!this.balance || this.balance.legal_balance <= 0) {
                return '0.00';
            }
            
            //1 多 2空
            //开多减去多担仓位的数量
            //开空减去孔丹仓位的数量
            let pamount = this.getDirectionAmount(d);
            let aamount = 0;
            if (this.modeIndex === 0) {
                aamount = this.balance.legal_balance / currentPrice * this.leverVal;
            } else {
                aamount = this.balance.legal_balance / (this.price !== '' ? this.$util.str2number(this.price) : currentPrice) * this.leverVal;
            }
            aamount = parseFloat(aamount * (1-parseFloat(this.current['fee_open']))).toFixed(this.current['decimals']);
            if (this.amounType === 0) {
                return aamount - pamount > 0 ? parseFloat(aamount - pamount).toFixed(this.current['decimals']) : 0;
            } else {
                let uamount = aamount - pamount > 0 ?
                    parseFloat((aamount - pamount) * (this.modeIndex === 0 ? currentPrice : (this.price !== '' ? this.$util.str2number(this.price) : currentPrice))).toFixed(this.current['decimals']) : 0;
                // if(uamount > 500000){
                // 	return '500000.00';
                // }
                return uamount;
            }
        },
        getDirectionAmount(d) {
            let list = this.position.position.filter(item => item.direction === d);
            let amount = 0
            if (list.length > 0) {
                for (let i = 0; i < list.length; i++) {
                    amount += parseFloat(list[i]['amount']) - parseFloat(list[i]['close'])
                }
            }
            return amount;
        },
        sliderChange(e){
            if(this.btnActive === 0){
                this.rate = e;
                let t = this.getTopAmount(1);
                let d = this.getTopAmount(2)
                this.amount = this.$util.str2number(this.$util.float(parseFloat((t > d ? t : d) * (e / 100)).toFixed(8)));
            }else{
                this.rate = e;
                let t = this.getPositionAmount(1);
                let d = this.getPositionAmount(2);
                this.amount = this.$util.str2number(this.$util.float(parseFloat((t > d ? t : d) * (e / 100)).toFixed(8)));
            }
        },
        getBalance(){
            if(this.isLogin){
                contractApi.getBalance(2,this.current['id']).then(res=>{
                    if(res.code === 200){
                        this.balance = res.data;
                        console.log('✅ 余额更新成功:', this.balance);
                    } else {
                        console.warn('⚠️ 余额更新失败:', res.message);
                    }
                }).catch(error => {
                    console.error('❌ 获取余额失败:', error);
                    // 如果是401错误，静默处理
                    if (error.message && error.message.includes('401')) {
                        console.log('ℹ️ 用户未登录，余额获取失败');
                        return;
                    }
                });
            }
        },
        getPositionLever(){
            let lever = this.$util.getCache('futures-lever','');
            if(lever !== ''){
                this.leverVal = parseInt(lever);
            }
        },
        setPositionLever(){
            this.$util.setCache('futures-lever',this.leverVal);
            this.leverArm = false;
        },
        getPositionModel(){
            let model = this.$util.getCache('positionModel','');
            if(model !== ''){
                this.positionModel = parseInt(model);
                if(this.positionModel === 0){
                    this.all = true;
                }else{
                    this.signal = true;
                }
            }else{
                this.positionModel = 0;
                this.all = true;
                this.signal = false;
            }
        },
        confirmPositionChange(){
              this.$util.setCache("positionModel",this.positionModel);
              this.marginModel = false;
        },
        positionChange(e){
            console.log(e);
            this.positionModel = e;
        },
        getContractCurrency(){
            console.log('📊 获取合约币种列表...');
            currencyApi.contractCurrencyList().then(res => {
                if (res && res.data && Array.isArray(res.data)) {
                    this.currency = res.data;
                    console.log('✅ 合约币种列表获取成功，币种数量:', res.data.length);
                    this.getCurrentCurrency();
                } else {
                    console.error('❌ 合约币种列表数据格式错误:', res);
                }
            }).catch(error => {
                console.error('❌ 获取合约币种列表失败:', error);
                
                // 如果是401错误，静默处理
                if (error.message && error.message.includes('401')) {
                    console.log('ℹ️ 用户未登录，合约币种列表获取失败');
                // 设置一个空的默认数据，避免页面崩溃
                    this.currency = [];
                    return;
                }
                
                // 其他错误也设置空数据
                this.currency = [];
            });
        },
        getCurrentCurrency(){
            try {
                console.log('🔄 获取当前合约币种配置...');
                
                // 确保币种列表已加载
                if (!this.currency || this.currency.length === 0) {
                    console.warn('⚠️ 币种列表尚未加载，延迟执行getCurrentCurrency');
                    setTimeout(() => {
                        this.getCurrentCurrency();
                    }, 1000);
                    return;
                }
                
                let current = this.$util.getCache(currentKey, '');
                if (current !== '') {
                    this.current = JSON.parse(current);
                    console.log('📊 从缓存加载当前币种:', this.current?.symbol);
                } else {
                    if (!this.currency[0] || !this.currency[0]['currency'] || !this.currency[0]['currency'][0]) {
                        console.error('❌ 币种列表格式错误，无法设置默认币种');
                        return;
                    }
                    this.current = this.currency[0]['currency'][0];
                    this.$util.setCache(currentKey, JSON.stringify(this.current));
                    console.log('📊 设置默认币种:', this.current?.symbol);
                }
                
                // 安全地调用各种初始化方法
                setTimeout(() => {
                    if (!klineCharts) {
                        this.createCharts();
                    }
                }, 500);
                
                setTimeout(() => {
                    this.connectSocket();
                }, 800);
                
                setTimeout(() => {
                    this.getCurrencyInfo();
                }, 1000);
                
            } catch (error) {
                console.error('❌ 获取当前合约币种失败:', error);
            }
        },
        getCurrencyInfo(){
            currencyApi.getCurrencyInfo(this.current['id'],2).then(res=>{
                this.currencyInfo = res.data.currency_info != null ? JSON.parse(res.data.currency_info):false;
                console.log(this.currencyInfo);
            })
        },
        setCurrentCurrency(item){
            this.$util.setCache(currentKey,JSON.stringify(item));
            const previousPeriod = klineCharts?.getPeriod?.();
            if (previousPeriod) {
                chartPeriod = {...previousPeriod};
            }
            invalidateKlineSession();
            _ticker = false;
            this.current = item;
            
            // Recreate the chart to give the final selected symbol its own datafeed
            // session; KLineChartPro does not cancel an in-flight datafeed request.
            if (klineCharts) {
                try {
                    klineCharts.destroy();
                } catch (error) {
                    console.warn('⚠️ 销毁旧K线图失败:', error);
                }
                klineCharts = false;
                const chartContainer = document.getElementById('chartBox');
                if (chartContainer) {
                    chartContainer.innerHTML = '';
                }
                this.$nextTick(() => this.createCharts());
            }
            
            this.subscribe();
            this.trades = [];
            
            // 只有在用户已登录的情况下才获取持仓信息
            if (this.isLogin) {
            this.getPosition();
            } else {
                console.log('ℹ️ 用户未登录，跳过持仓信息获取');
                // 设置空的持仓数据
                this.position = {
                    position: [],
                    totalAmount: []
                };
            }
            
            this.amount = '';
            this.price = '';
            this.wprice = '';
        },
        tableToggle(item, index) {
            this.tableActive = index;
            this.coinName = item.name;
            this.coinType = item.type;
        },
        aboutCoinShow() {
            this.aboutCoin = true;
        },
        setNum() {
            // this.timer = setInterval(() => {
            //     this.List.forEach(item => {
            //         item.price = Math.random().toFixed(5)
            //     })
            // }, 2000)
        },
        numSelect(e) {
            this.decimal = e;
        },
        toDetail() {
            this.$router.push("/HomeView/futures/futuresData")
        },
        priveChange(e) {
            console.log(e)
            this.priceTypeVal = e;
        },
        onMessage(data){
            console.log('📨 合约onMessage:', {
                type: data.type,
                currentCurrency: this.current?.symbol,
                currencyId: this.current?.id
            })
            
            if(data.type === 203){
                console.log('📊 收到合约成交记录数据 (type 203)')
                const date = new Date(data.data.data.E);
                let trades = this.trades;
                if (trades.length > 50) {
                    trades = trades.slice(1);
                }
                let h = date.getHours();
                let m = date.getMinutes();
                let s = date.getSeconds();
                trades.push({
                    time: (h<10 ? '0'+h:h) + ':' + (m<10?'0'+m:m) + ':' + (s<10?'0'+s:s),
                    price: data.data.data.p,
                    vol: data.data.data.q,
                    type : data.data.m
                });
                this.trades = trades;
            }
            if(data.type === 202){
                console.log('📊 收到合约市场数据 (type 202)')
                this.market = data.data.data;
                if (timestamp === 0) {
                    timestamp = this.market['T'];
                }
                if (timestamp !== this.market['T']) {
                    timestamp = this.market['T'];
                }
                if (!timecaluc) {
                    this.calacTime();
                }
            }
            if(data.type === 200){
                console.log('🎯 收到合约ticker数据 (type 200):', data.data)
                
                try {
                    _ticker = this.$util.getCurrentTicker(this.current['id'], data.data.data);
                    
                    if (_ticker && Object.keys(_ticker).length > 0) {
                        console.log('✅ 成功获取合约ticker数据:', _ticker)
                        
                        let current = this.current;
                        current['new_price'] = _ticker['c'];
                        current['change_rate'] = _ticker['P'];
                        current['high_price'] = _ticker['h'];
                        current['low_price'] = _ticker['l'];
                        current['quantity'] = _ticker['v'];
                        current['quota'] = _ticker['q'];
                        this.current = current;
                        
                        console.log('📊 合约价格更新成功:', {
                            symbol: this.current.symbol,
                            price: _ticker['c'],
                            ticker: _ticker,
                            _ticker: !!_ticker
                        })
                        
                        this.calacPosition(data.data.data);
                    } else {
                        console.warn('⚠️ getCurrentTicker返回空数据，当前币种ID:', this.current?.id)
                        console.log('🔍 可用的ticker数据:', data.data.data ? Object.keys(data.data.data) : 'null')
                    }
                } catch (error) {
                    console.error('❌ 处理合约ticker数据失败:', error)
                }
            }
            if(data.type === 201){
                console.log('📊 收到合约深度数据 (type 201)')
                //深度数据
                amax = 0;
                bmax = 0;
                let asks = data.data.data.a;
                let bids = data.data.data.b;
                asks.sort((a, b) => {
                    return a[1] - b[1];
                });
                asks.map((v, i) => {
                    if (amax < parseFloat(v[1])) {
                        amax = v[1];
                    }
                });

                for (let i = 0; i < asks.length; i++) {
                    asks[i][3] = parseFloat(asks[i][1] / amax).toFixed(8);
                }
                asks.reverse();
                bids.map((v, i) => {
                    if (bmax < parseFloat(v[1])) {
                        bmax = v[1];
                    }
                });
                bids.reverse();
                for (let i = 0; i < bids.length; i++) {
                    bids[i][3] = parseFloat(bids[i][1] / bmax).toFixed(8);
                }
                this.asks = asks;
                this.bids = bids;
            }
            
            // 记录其他消息类型
            if (![200, 201, 202, 203].includes(data.type)) {
                console.log('📝 合约其他消息类型:', {
                    type: data.type,
                    hasData: !!data.data
                })
            }
        },
        calacTime() {
            console.log("资金废率倒计时");
            if(timecaluc){
                clearInterval(timecaluc);
            }
            console.log(timestamp);
            timecaluc = setInterval(() => {
                const currentTimestamp = Date.now();
                const timeRemaining = timestamp - currentTimestamp;
                const hoursRemaining = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutesRemaining = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
                const secondsRemaining = Math.floor((timeRemaining % (1000 * 60)) / 1000);
                this.timeInt = (hoursRemaining < 10 ? '0' + hoursRemaining : hoursRemaining) + ':' +
                    (minutesRemaining < 10 ? '0' + minutesRemaining : minutesRemaining) + ':' +
                    (secondsRemaining < 10 ? '0' + secondsRemaining : secondsRemaining)
            }, 1000);
        },
        connectSocket(){
            if (!socket) {
                const deviceId = this.$util.getCache('deviceId');
                const url = config['BASE_WSS'] + '/?token=' + deviceId + '$contract' + '&sub=contract';
                console.log('🔌 合约WebSocket连接URL:', url)
                
                let _this = this;
                socket = new WebSocket(url);
                
                socket.onopen = () => {
                    console.log('✅ 合约WebSocket连接成功 (contract频道)')
                    
                    setTimeout(() => {
                        if(socketInterval){
                            clearInterval(socketInterval);
                        }
                        socketInterval = setInterval(() => {
                            if(this.userId && socket){
                                try{
                                    socket.send(JSON.stringify({
                                        event: 'updateCuserId',
                                        uid: _this.userId
                                    }));
                                    console.log('📡 定期发送合约用户ID:', _this.userId)
                                }catch (e){
                                    console.error('❌ 发送合约用户ID失败:', e)
                                    clearInterval(socketInterval);
                                    socket = false;
                                    _this.connectSocket();
                                }
                            }
                        }, 5000);
                    }, 1500);
                    this.subscribe();
                    
                    socket.onmessage = (data) => {
                        try {
                            const parsedData = JSON.parse(data.data)
                            console.log('📨 合约WebSocket收到消息:', {
                                type: parsedData.type,
                                hasData: !!parsedData.data,
                                rawDataSize: data.data.length
                            })
                            this.onMessage(parsedData);
                        } catch (error) {
                            console.error('❌ 合约WebSocket消息解析失败:', error, data.data)
                        }
                    }
                }
                
                socket.onerror = (error) => {
                    console.error('❌ 合约WebSocket连接错误:', error)
                }
                
                socket.onclose = () => {
                    console.log('🔌 合约WebSocket连接关闭，3秒后重连...')
                    socket = false
                    setTimeout(() => {
                        _this.connectSocket()
                    }, 3000)
                }
            }
        },
        subscribe(){
            if (socket && socket.readyState === WebSocket.OPEN && this.current) {
                const subscribeMsg = {
                    event: "contrade_depth_subscribe",
                    cm_id: 2,
                    currency_id: this.current['id']
                }
                socket.send(JSON.stringify(subscribeMsg));
                console.log('📡 合约WebSocket订阅发送:', subscribeMsg)
            } else {
                console.warn('⚠️ 合约WebSocket未连接或币种未选择，跳过订阅', {
                    wsReady: socket && socket.readyState === WebSocket.OPEN,
                    hasCurrent: !!this.current
                })
            }
        },
        // 将Vue i18n语言代码映射到KLineChartPro语言代码
        // KLineChartPro默认只支持 en-US 和 zh-CN，其他语言需要注册
        getKlineLocale() {
            const vueLocale = this.$i18n?.locale || 'en-US';
            // KLineChartPro实际支持的语言代码（默认只支持这两种）
            // 其他语言会回退到 en-US
            const localeMap = {
                'en-US': 'en-US',
                'zh_CN': 'zh-CN',
                'zh_Hant': 'zh-CN', // 繁体中文也使用简体中文
                'ru': 'en-US', // 俄语回退到英文
                'th': 'en-US', // 泰语回退到英文
                'ja': 'en-US', // 日语回退到英文
                'ko': 'en-US', // 韩语回退到英文
                'au': 'en-US', // 澳大利亚英语使用英文
                'gm': 'en-US'  // 德语回退到英文
            };
            const klineLocale = localeMap[vueLocale] || 'en-US';
            console.log('🌐 K线图语言映射:', { vueLocale, klineLocale });
            return klineLocale;
        },
        async createCharts(){
            if(klineCharts){
                console.log('📊 K线图表已存在，跳过初始化');
                return false;
            }

            if (!this.current || !this.current['id']) {
                return false;
            }

            const chartContainer = document.getElementById('chartBox');
            if (!chartContainer) {
                return false;
            }

            const session = ++klineChartSession;
            const chartCurrency = {
                id: this.current['id'],
                ticker: this.current['symbol'] + 'USDT'
            };
            last = undefined;
            
            console.log('📊 开始创建合约K线图表...');
            
            try {
            let _this = this;
            class CustomDatafeed {
                searchSymbols(search) {
                }
                async getHistoryKLineData(symbol, period, from, to) {
                    try {
                        const isActiveSession = () => {
                            const activeSymbol = klineCharts?.getSymbol?.();
                            const activePeriod = klineCharts?.getPeriod?.();

                            return session === klineChartSession
                                && (!activeSymbol || activeSymbol.ticker === chartCurrency.ticker)
                                && (!activePeriod || activePeriod.text === period.text);
                        };

                        if (!isActiveSession() || symbol?.ticker !== chartCurrency.ticker) {
                            return [];
                        }

                        console.log('📊 获取合约K线历史数据:', {
                            symbol,
                            period: period.text,
                            currencyId: chartCurrency.id
                        });
                        
                        let res = await currencyApi.contractLine({
                            interval: period.text,
                            currency_id: chartCurrency.id,
                            limit: 1000
                        });

                        if (!isActiveSession() || symbol?.ticker !== chartCurrency.ticker) {
                            return [];
                        }

                        _this.$util.setCache('local-period', JSON.stringify(period));
                        chartPeriod = {...period};
                        
                        if (!res || !res.data || !Array.isArray(res.data)) {
                            console.error('❌ K线数据格式错误:', res);
                            return [];
                        }
                        
                        console.log('📊 合约K线数据获取成功，周期:', period.text, '数据条数:', res.data.length);
                        
                        let data = res.data.map((item) => {
                            return {
                                timestamp: item['time'],
                                open: item['open'],
                                high: item['high'],
                                low: item['low'],
                                close: item['close'],
                                volume: item['vol'],
                                turnover: item['amount'],
                            }
                        });
                        
                        const latest = data[data.length - 1];
                        if (!last || (latest && latest.timestamp >= last.timestamp)) {
                            last = latest;
                        }
                        
                        return data;
                    } catch (error) {
                        console.error('❌ 获取合约K线历史数据失败:', error);
                        return [];
                    }
                }
                subscribe(symbol, period, callback) {
                    const subscriptionToken = ++klineSubscriptionToken;
                    console.log('📡 合约K线图订阅请求:', { 
                        symbol, 
                        period: period.text, 
                        _ticker: !!_ticker,
                        tickerKeys: _ticker ? Object.keys(_ticker) : null
                    })
                    
                    // 🔥 修复：不阻塞订阅，而是在定时器中检查
                    console.log('✅ 开始合约K线实时数据订阅（不等待ticker）:', symbol)
                    if(upset !== false){
                        clearInterval(upset);
                    }
                    upset = setInterval(()=>{
                        const activeSymbol = klineCharts?.getSymbol?.();
                        const activePeriod = klineCharts?.getPeriod?.();
                        if (session !== klineChartSession
                            || subscriptionToken !== klineSubscriptionToken
                            || symbol?.ticker !== chartCurrency.ticker
                            || (activeSymbol && activeSymbol.ticker !== chartCurrency.ticker)
                            || (activePeriod && activePeriod.text !== period.text)) {
                            return;
                        }

                        // 🔥 每次执行时检查_ticker是否可用
                        if (!_ticker || !_ticker.c) {
                            console.log('⏳ 合约等待ticker数据...', {
                                hasTicker: !!_ticker,
                                tickerKeys: _ticker ? Object.keys(_ticker) : null,
                                period: period.text
                            })
                            return
                        }
                        
                        if(period.text === '1s'){
                            firstPrice = parseFloat(_ticker['c']);
                            const data = {
                                timestamp:_ticker['E'],
                                open:firstPrice,
                                close:firstPrice,
                                high:firstPrice,
                                low:firstPrice,
                                volume:parseInt(_ticker['Q'] || 0),
                                turnover:parseInt(_ticker['Q'] || 0),
                            }
                            console.log('📊 合约K线1秒数据更新:', data)
                            callback(data);
                        }else{
                            let minint = time[period.text] * 60 * 1000;
                            firstPrice = parseFloat(_ticker['c']);
                            let data;
                            
                            // 🔥 修复：检查 last 是否存在，避免 undefined 错误
                            if (!last || !last.timestamp) {
                                // 如果 last 不存在，创建新的数据点
                                data = {
                                    timestamp: parseInt(_ticker['E']),
                                    open: firstPrice,
                                    close: firstPrice,
                                    high: firstPrice,
                                    low: firstPrice,
                                    volume: parseInt(_ticker['Q'] || 0),
                                    turnover: parseInt(_ticker['Q'] || 0),
                                };
                            } else if(parseInt(_ticker['E']) - last['timestamp'] > minint){
                                data = {
                                    timestamp:parseInt(_ticker['E']),
                                    open:firstPrice,
                                    close:firstPrice,
                                    high:firstPrice,
                                    low:firstPrice,
                                    volume:parseInt(_ticker['Q'] || 0),
                                    turnover:parseInt(_ticker['Q'] || 0),
                                };

                            }else{
                                data = {
                                    timestamp:last['timestamp'],
                                    open:last['open'],
                                    close:firstPrice,
                                    high:last['high'] < firstPrice ? firstPrice : last['high'],
                                    low:last['low'] > firstPrice ? firstPrice : last['low'],
                                    volume:last['volume'] + parseInt(_ticker['Q'] || 0),
                                    turnover:last['volume'] + parseInt(_ticker['Q'] || 0),
                                };
                            }
                            last = data;
                            console.log('📊 合约K线数据更新:', { 
                                period: period.text, 
                                ticker: _ticker,
                                data 
                            })
                            callback(data);
                        }
                    },500);
                }
                unsubscribe(symbol, period) {
                    klineSubscriptionToken += 1;
                    if (upset !== false) {
                        clearInterval(upset);
                        upset = false;
                    }
                }
            }
            // 获取K线图语言代码
            const klineLocale = this.getKlineLocale();
            
            // KLineChartPro已内置zh-CN和en-US语言包，无需手动加载
            // 只需在创建图表时设置locale参数即可
            console.log('🔧 K线图语言设置:', klineLocale);
            
            // 合约页面强制使用15分钟作为默认周期，忽略缓存
            let localPeriod = chartPeriod || {
                multiplier: 15, timespan: 'minute', text: '15m'
            };
            // 清空容器内容，防止重复
            chartContainer.innerHTML = '';
            
            console.log('📊 初始化合约K线图表，语言:', klineLocale);
            
            // 确保主题设置正确
            const currentTheme = this.userTheme || 'dark';
            console.log('🎨 当前主题:', currentTheme);
            
            // 无需等待，库已内置语言包
            
            klineCharts = new KLineChartPro({
                container: chartContainer,
                watermark: "DBG Exchange",
                theme: currentTheme,
                locale: klineLocale, // 使用当前语言设置
                timezone: this.$util.getCache('time_zone') || 'Asia/Shanghai',
                // 初始化标的信息
                symbol: {
                    ticker: chartCurrency.ticker,
                    pricePrecision:this.current['decimals'],
                    logo:this.current['icon'],
                    type:"ADRC"
                },
                // 初始化周期
                period: localPeriod,
                periods:[
                    {multiplier:1,timespan:'minute',text:'1m'},
                    {multiplier:5,timespan:'minute',text:'5m'},
                    {multiplier:15,timespan:'minute',text:'15m'},
                    {multiplier:30,timespan:'minute',text:'30m'},
                    {multiplier:60,timespan:'minute',text:'1H'},
                    {multiplier:240,timespan:'minute',text:'4H'},
                    {multiplier:720,timespan:'minute',text:'12H'},
                    {multiplier:1440,timespan:'minute',text:'1D'},
                    {multiplier:10080,timespan:'minute',text:'1W'}
                ],
                subIndicators: [],
                datafeed: new CustomDatafeed()
            })
            
            // KLineChartPro支持setLocale方法，在创建后也可以设置语言
            // 但为了确保设置弹窗也使用正确语言，我们在创建后再次调用setLocale
            if (klineCharts && klineCharts.setLocale) {
                try {
                    klineCharts.setLocale(klineLocale);
                    console.log('✅ 合约K线图语言设置成功:', klineLocale);
                } catch (error) {
                    console.warn('⚠️ 设置K线图语言失败:', error);
                }
            }
            
            console.log('✅ 合约K线图表创建成功，语言:', klineLocale);
            console.log('🔍 K线图语言配置:', {
                vueLocale: this.$i18n?.locale,
                klineLocale: klineLocale,
                hasSetLocale: !!klineCharts?.setLocale,
                currentLocale: klineCharts?.getLocale ? klineCharts.getLocale() : 'unknown'
            });
            
        } catch (error) {
            console.error('❌ 创建合约K线图表失败:', error);
            klineCharts = false;
        }
    },
    refreshKlineChart() {
        console.log('🔄 强制刷新K线图...');
        // 销毁旧图表
        if (klineCharts) {
            try {
                console.log('🗑️ 销毁旧K线图...');
                invalidateKlineSession();
                klineCharts.destroy();
            } catch (error) {
                console.warn('⚠️ 销毁旧K线图失败:', error);
            }
            klineCharts = false;
        }
        
        // 清空容器内容
        const chartContainer = document.getElementById('chartBox');
        if (chartContainer) {
            chartContainer.innerHTML = '';
        }
        
        // 延迟重新创建图表，确保DOM更新完成
        setTimeout(() => {
            this.createCharts();
        }, 300);
    },
    
    // 获取本地化标题
    getLocalizedTitle(title) {
        if (!title) return '';
        
        // 如果是字符串，直接返回
        if (typeof title === 'string') {
            return title;
        }
        
        // 如果是对象，尝试解析多语言
        if (typeof title === 'object') {
            try {
                // 如果是JSON字符串，先解析
                if (typeof title === 'string' && title.startsWith('{')) {
                    title = JSON.parse(title);
                }
                
                // 获取当前语言
                const currentLang = this.$i18n?.locale || 'en-US';
                
                // 根据当前语言返回对应文本
                if (currentLang === 'zh_CN') {
                    return title['zh_CN'] || title['zh_Hant'] || title['en-US'] || '加密货币';
                } else if (currentLang === 'zh_Hant') {
                    return title['zh_Hant'] || title['zh_CN'] || title['en-US'] || '加密货币';
                } else if (currentLang === 'en-US') {
                    return title['en-US'] || title['zh_CN'] || title['zh_Hant'] || 'Crypto';
                } else {
                    // 默认返回中文
                    return title['zh_CN'] || title['zh_Hant'] || title['en-US'] || '加密货币';
                }
            } catch (error) {
                console.warn('⚠️ 解析多语言标题失败:', error);
                return '加密货币';
            }
        }
        
        return '加密货币';
    }
    },
    beforeUnmount() {
        try {
            console.log("合约页面 beforeUnmount");
            invalidateKlineSession();
            
            // 清理数据更新定时器
            if (this.dataUpdateTimer) {
                clearInterval(this.dataUpdateTimer);
                this.dataUpdateTimer = null;
            }
            
            // 清理数据更新定时器
            if (this.dataUpdateTimer) {
                clearInterval(this.dataUpdateTimer);
                this.dataUpdateTimer = null;
            }
            
            // 清理诊断定时器
            if (this.diagnosticInterval) {
                clearInterval(this.diagnosticInterval);
                this.diagnosticInterval = null;
            }
            
            clearInterval(socketInterval);
            if (socket) {
                socket.close();
            }
            socket = false;
            if (klineCharts) {
                klineCharts.destroy();
            }
            klineCharts = false;
            timecaluc = false;
        }catch (e){
            console.log(e);
        }
    },
}
